/* Persist valid Google Ads click IDs into private Shopify cart attributes. */
(function () {
  'use strict';

  if (window.__bbGoogleAdsClickAttributionLoaded) return;
  window.__bbGoogleAdsClickAttributionLoaded = true;

  var SCHEMA_VERSION = '3';
  var MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000;
  var STORAGE_KEY = 'bb:google-ads:click-attribution:v3';
  var LEGACY_STORAGE_KEY = 'bb:google-ads:click-attribution:v2';
  var SESSION_SYNC_KEY = STORAGE_KEY + ':synced';
  var CLICK_FIELDS = ['gclid', 'gbraid', 'wbraid'];
  var UTM_FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var syncInFlight = null;

  function safeStorage(kind) {
    try { return window[kind]; } catch (_error) { return null; }
  }

  function read(store, key) {
    try { return store ? store.getItem(key) : null; } catch (_error) { return null; }
  }

  function write(store, key, value) {
    try { if (store) store.setItem(key, value); } catch (_error) {}
  }

  function remove(store, key) {
    try { if (store) store.removeItem(key); } catch (_error) {}
  }

  function parse(value) {
    try {
      var parsed = JSON.parse(value || '{}');
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : null;
    } catch (_error) {
      return null;
    }
  }

  function clean(value, maxLength) {
    var text = String(value || '').trim();
    return text ? text.slice(0, maxLength) : '';
  }

  function validClickId(value) {
    return /^[A-Za-z0-9._~-]{8,512}$/.test(String(value || ''));
  }

  function selectedClick(params) {
    for (var index = 0; index < CLICK_FIELDS.length; index += 1) {
      var type = CLICK_FIELDS[index];
      var value = clean(params.get(type), 512);
      if (validClickId(value)) return { type: type, value: value };
    }
    return null;
  }

  function incomingAttribution() {
    var params = new URLSearchParams(window.location.search || '');
    var click = selectedClick(params);
    if (!click) return null;
    var attribution = {
      schema: SCHEMA_VERSION,
      click_id_type: click.type,
      click_id: click.value,
      captured_at_ms: Date.now(),
      landing_path: clean(window.location.pathname || '/', 500)
    };
    UTM_FIELDS.forEach(function (field) {
      var value = clean(params.get(field), 255);
      if (value) attribution[field] = value;
    });
    return attribution;
  }

  function validAttribution(value) {
    if (!value || (value.schema !== SCHEMA_VERSION && value.schema !== '2')) return false;
    if (CLICK_FIELDS.indexOf(value.click_id_type) === -1) return false;
    if (!validClickId(value.click_id)) return false;
    if (!Number.isSafeInteger(value.captured_at_ms)) return false;
    return value.captured_at_ms <= Date.now() + 60 * 1000 &&
      Date.now() - value.captured_at_ms <= MAX_AGE_MS;
  }

  function privateAttributes(attribution) {
    var values = {
      '__bb_ga_schema': SCHEMA_VERSION,
      '__bb_ga_id_type': attribution.click_id_type,
      '__bb_ga_click_id': attribution.click_id,
      '__bb_ga_captured_at': new Date(attribution.captured_at_ms).toISOString(),
      '__bb_ga_landing_path': attribution.landing_path || '/',
      '__bb_ga_consent': 'unspecified'
    };
    UTM_FIELDS.forEach(function (field) {
      values['__bb_ga_' + field] = attribution[field] || '';
    });
    return values;
  }

  function cartUpdate(attributes) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    var endpoint = (root || '/') + 'cart/update.js';
    return window.fetch(endpoint, {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (response) {
      if (!response.ok) throw new Error('cart_attribute_update_failed');
      return response.json();
    });
  }

  function sync(attribution, local, session) {
    if (!validAttribution(attribution)) return Promise.resolve(false);
    var fingerprint = [attribution.click_id_type, attribution.click_id, attribution.captured_at_ms].join(':');
    if (read(session, SESSION_SYNC_KEY) === fingerprint) return Promise.resolve(true);
    if (syncInFlight) return syncInFlight;
    // Store the click before the POST: a fast add can navigate to /cart before it answers, and the cart re-asserts
    // the click from storage after Bird replaces the attribute set. Only a confirmed POST marks the session synced.
    attribution.schema = SCHEMA_VERSION;
    write(local, STORAGE_KEY, JSON.stringify(attribution));
    syncInFlight = cartUpdate(privateAttributes(attribution)).then(function () {
      remove(local, LEGACY_STORAGE_KEY);
      write(session, SESSION_SYNC_KEY, fingerprint);
      return true;
    }).catch(function () {
      return false;
    }).then(function (result) {
      syncInFlight = null;
      return result;
    });
    return syncInFlight;
  }

  var local = safeStorage('localStorage');
  var session = safeStorage('sessionStorage');
  var current = incomingAttribution();
  var stored = parse(read(local, STORAGE_KEY));
  if (!validAttribution(stored)) stored = parse(read(local, LEGACY_STORAGE_KEY));
  var attribution = validAttribution(current) ? current : (validAttribution(stored) ? stored : null);
  if (attribution) sync(attribution, local, session);

  // Read-only view for the cart: Bird's cartAttributesUpdate replaces the whole attribute set, so the v3 cart
  // re-asserts these after Bird writes. Never syncs or changes storage itself.
  window.BBGoogleAdsClickAttribution = {
    attributes: function () {
      var saved = parse(read(local, STORAGE_KEY));
      return validAttribution(saved) ? privateAttributes(saved) : {};
    }
  };
})();
